import { render, staticRenderFns } from "./DisclosureList.vue?vue&type=template&id=412af01c&scoped=true&"
import script from "./DisclosureList.vue?vue&type=script&lang=js&"
export * from "./DisclosureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412af01c",
  null
  
)

export default component.exports